export default Object.freeze({ UPDATE_EDITOR_VALUE: "UPDATE_EDITOR_VALUE" });
